import React from 'react';
import { useNavigate } from 'react-router-dom';
import PixelLogo from './PixelLogo';
import CTAButton from './CTAButton';
import { FiPlus, FiArrowRight } from 'react-icons/fi';

const Hero = () => {
    const navigate = useNavigate();
    return (
        <div className='relative pt-28 pb-0 md:pt-48 md:pb-32 overflow-hidden'>

            <div className='container-custom relative z-10'>
                <div className='grid grid-cols-1 md:grid-cols-2 items-center justify-between gap-8 md:gap-16'>
                    {/* Text Column */}
                    <div className='text-center md:text-left animate-fade-in-up'>
                        <h1 className='text-5xl md:text-8xl font-bold mb-8 leading-tight tracking-tight text-slate-900'>
                            Beyond Innovation
                        </h1>
                        <p className='text-xl md:text-xl text-slate-600 mb-10 leading-relaxed'>
                            We're the technology partners behind innovative companies like <a href="https://onscript.ai" className="text-[#456EF2] hover:underline italic" target="_blank" rel="noopener noreferrer">OnScript AI</a>, delivering cutting-edge artificial intelligence solutions.
                        </p>
                        <div className='flex flex-col sm:flex-row gap-4 justify-center md:justify-start items-center'>
                            <CTAButton icon={FiPlus} onClick={() => navigate('/contact')} />
                            <a href="#services" className='px-8 py-3 text-slate-900 font-semibold hover:text-primary transition-colors flex items-center gap-2 group'>
                                Our Services
                                <FiArrowRight className="transform group-hover:translate-x-1 transition-transform" />
                            </a>
                        </div>
                    </div>

                    {/* Logo Column */}
                    <div className='flex justify-center md:justify-end'>
                        <PixelLogo
                            size={80}
                            className="shrink-0"
                            images={[
                                '/images/shapes/0.png',
                                '/images/shapes/1.png',
                                '/images/shapes/2.png',
                                '/images/shapes/3.png',
                                '/images/shapes/4.png',
                                '/images/shapes/5.png',
                                '/images/shapes/6.png'
                            ]}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hero;
